import React from 'react';
import { Icon } from 'antd';
import cn from 'classnames';
import EditableField from '../../shared/ui/EditableField';
import { ReactComponent as NotebookIcon } from '../../../../resource/NoteBookIcon.svg';
import { useFieldController } from '../../../../helpers/formManager';
import Field from '../../shared/ui/Field';
import { fieldNames } from '../../shared/configs/acceptanceForm';
import styles from './index.module.scss';

const AcceptanceName = ({ className, mode, value }) => {
  return (
    <div className={cn(styles.root, className)}>
      <div className={styles.iconWrap}>
        <Icon className={styles.icon} component={NotebookIcon} />
      </div>
      {Boolean(value) ? (
        <EditableField value={value} mode={EditableField.modes.readable} />
      ) : (
        <Controller mode={mode} />
      )}
    </div>
  );
};

AcceptanceName.modes = { ...EditableField.modes };

export default AcceptanceName;

const fieldProps = {
  placeholder: 'Придумайте уникальное наименование приема помещений',
};

const controllerProps = {
  name: fieldNames.main.name,
  defaultValue: '',
};

function Controller({ mode }) {
  const { field, fieldState } = useFieldController(controllerProps);

  return (
    <Field.Memoized
      type={Field.types.editableInput}
      errorMessage={fieldState.error?.message}
      rootCN={styles.formItem}
      value={field.value}
      onChange={field.onChange}
      mode={mode}
      fieldProps={fieldProps}
    />
  );
}
